export default __webpack_public_path__ + "static/media/stce.5f2d0e2a.jfif";